/**
 * A member of a study as the pickers list them, from `GET study/:id/members` (users decisions 14 and
 * 53). Any member may read the list, so it carries who someone is and nothing about what they may do.
 *
 * The wire types match spdata-api's `StudyMember` in `src/study/study.members.service.ts`.
 */

/** One row of `GET study/:id/members`. */
export interface NetworkStudyMember {
  /** Hex, the same id paged-users sends. */
  identifier: string;
  name: string;
  /** The avatar route, left out when the member has none. */
  avatar?: string;
  /** From the account's `users.staff`. No picker reads it. */
  staff: boolean;
  /** Sent only when the caller holds Manage users (users decision 53). */
  email?: string;
}

export interface NetworkStudyMembers {
  members: NetworkStudyMember[];
}

/** One member in a picker. */
export interface StudyMember {
  identifier: string;
  name: string;
  avatar?: string;
  /** Empty when the server held it back: the reader does not hold Manage users (users decision 53). */
  email: string;
}

export const studyMemberFromBackend = (member: NetworkStudyMember): StudyMember => ({
  identifier: member.identifier,
  name: member.name,
  avatar: member.avatar,
  email: member.email ?? ''
});

/** What a picker calls a member: their name, since the email is empty unless the reader holds Manage users (users decision 53). */
export const studyMemberLabel = (member: StudyMember): string => member.name || member.email;
